import "./DrawerDetailsDataKeyValueComponent.scss";
import React from "react";

interface DrawerDetailsDataKeyValueComponentProps {
    title: string,
}

const DrawerDetailsDataKeyValueComponent = (props: React.PropsWithChildren<DrawerDetailsDataKeyValueComponentProps>) => {
    const {title,children} = props;
    return (
            <div className={'drawer-key-value'}>
                <div className={'drawer-key'}>
                    {title}
                </div>
                <div className={'drawer-value'}>
                    {children}
                </div>
            </div>
    );

};

export default DrawerDetailsDataKeyValueComponent;